import React from "react";
import { WorkProjectShell } from "./WorkProjectShell";
import {
  WorkSplitRow,
  WorkMediaFrame,
  WorkTextStack,
  WorkSectionHeading,
  ConcludeContainer,
} from "./styles";
import { ProjectDetails } from "../../../DesignSystem/ProjectDetails";

export default function BremerhavenGuideIOS() {
  const ProjectBG = require("../../../../assets/videos/bremerhaven-guide/t3.png");
  const T1 = require("../../../../assets/videos/bremerhaven-guide/t1.png");
  const T2 = require("../../../../assets/videos/bremerhaven-guide/t2.png");
  const T3 = require("../../../../assets/videos/bremerhaven-guide/t3.png");
  const T4 = require("../../../../assets/videos/bremerhaven-guide/t4.png");

  return (
    <WorkProjectShell
      posterSrc={ProjectBG}
      title="BremerhavenGuide — immersive coastal exploration"
      lead={
        <p>
          Discover Bremerhaven&apos;s sights and maritime heritage with curated
          tours, a live map, rich media, and AR highlights—your companion for
          self-guided discovery.
        </p>
      }
    >
      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T1}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremerhaven-guide/1_BHV.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Tailored tours</WorkSectionHeading>
          <p>
            Historical and fishery harbor tours—or build your own route through
            the city&apos;s stories.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T2}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremerhaven-guide/2_BHV.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Interactive digital map</WorkSectionHeading>
          <p>
            See your position, the tour path, and each destination with
            directions so you stay oriented.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow>
        <WorkMediaFrame>
          <video controls poster={T3}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremerhaven-guide/3_BHV.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Multimedia at every stop</WorkSectionHeading>
          <p>
            Video, audio, imagery, and text bring each attraction to life and
            deepen context.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <WorkSplitRow $reverse>
        <WorkMediaFrame>
          <video controls poster={T4}>
            <source
              src="https://bharathvadde.s3.ap-south-1.amazonaws.com/bremerhaven-guide/4_BHV.mp4"
              type="video/mp4"
            />
          </video>
        </WorkMediaFrame>
        <WorkTextStack>
          <WorkSectionHeading>Augmented reality</WorkSectionHeading>
          <p>
            Selected POIs add AR layers—visualizations, panoramas, and playful
            digital overlays on the real scene.
          </p>
        </WorkTextStack>
      </WorkSplitRow>

      <ConcludeContainer>
        <p>
          Free after provider activation; nominated under &quot;Future
          Bremerhaven&quot; at Tourismuspreis Bremen und Bremerhaven 2022 for
          sustainability, creativity, and innovation.
        </p>
      </ConcludeContainer>

      <ProjectDetails
        details={[
          { label: "Project Name", value: "BremerhavenGuide" },
          { label: "Period", value: "01.2022 - 09.2022" },
          { label: "Client", value: "Erlebnis BremerhavenGuide GmbH" },
          {
            label: "Engine & Tools",
            value: "Unity, Mapbox, AR Foundation, C#",
          },
          { label: "Platform", value: "Mobile" },
          { label: "Company", value: "Radiusmedia KG" },
          { label: "Tags", value: "AR" },
        ]}
      />
    </WorkProjectShell>
  );
}
